import React from 'react';
import { JdsTag } from '../../../components/jds/JdsTag';
import {
  formatBenefit,
  formatCurrency,
  formatCycle,
  getMonthlyEquivalent,
} from '../utils';

const SUMMARY_ITEMS = 3;

const META_ROWS = [
  {
    key: 'displayClient',
    label: 'Visível ao cliente',
    format: (plan) => (plan.displayClient ? 'Sim' : 'Não'),
  },
];

export function PlanCard({ plan, selected, onToggleSelected }) {
  const planItems = plan.planItems ?? [];
  const monthly = getMonthlyEquivalent(plan);
  return (
    <div className="jds-card h-100 d-flex flex-column">
      <div className="d-flex align-items-start justify-content-between mb-4">
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: 'var(--space-8)' }}
        >
          <h2 className="jds-title-sm">{plan.name}</h2>
          <JdsTag color="brand" label={formatCycle(plan.cycleDays)} />
        </div>
        <JdsTag
          dot
          label={plan.active ? 'Ativo' : 'Inativo'}
          color={plan.active ? 'success' : 'error'}
        />
      </div>

      <label
        className="d-flex align-items-center mb-4 text-muted"
        style={{ gap: 'var(--space-8)', minHeight: 24, cursor: 'pointer' }}
      >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelected(plan.id)}
        />
        Incluir no comparativo
      </label>

      <div className="mb-4">
        <span className="jds-title-lg">{formatCurrency(plan.amount)}</span>
        <span className="text-muted">
          {' '}
          / {formatCycle(plan.cycleDays).toLowerCase()}
        </span>
        {monthly != null && (
          <small className="d-block text-muted">
            equivale a {formatCurrency(monthly)} / mês
          </small>
        )}
      </div>

      <div className="mb-6">
        {planItems.length === 0 ? (
          <small className="text-muted">Nenhum produto incluído.</small>
        ) : (
          <>
            {planItems.slice(0, SUMMARY_ITEMS).map((planItem) => (
              <div
                key={planItem.item.id}
                className="d-flex justify-content-between"
                style={{ gap: 'var(--space-8)' }}
              >
                <span>{planItem.item.name}</span>
                <span className="text-muted text-nowrap">
                  {formatBenefit(planItem)}
                </span>
              </div>
            ))}
            {planItems.length > SUMMARY_ITEMS && (
              <small className="text-muted">
                + {planItems.length - SUMMARY_ITEMS} produtos (veja no
                comparativo)
              </small>
            )}
          </>
        )}
      </div>

      <dl className="mb-0 mt-auto">
        {META_ROWS.map(({ key, label, format }) => (
          <div
            key={key}
            className="d-flex justify-content-between"
            style={{
              padding: 'var(--space-8) 0',
              borderTop:
                'var(--stroke-small) solid var(--border-neutral-subtle)',
            }}
          >
            <dt className="text-muted mb-0" style={{ fontWeight: 'inherit' }}>
              {label}
            </dt>
            <dd className="mb-0 text-right">{format(plan)}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
